$(document).ready(function(){
    function closeFilterDrawer(){
        $("html").css("overflow", "auto");
        $(".ctm_filter_sidebar").removeClass("open");
    }

    $(document).on("click",".filters-toolbar .btn-filter",function() {
        $("html").css("overflow", "hidden");
        $('.filter_accodion').removeClass('active');
        $('#new-arrivals').addClass('active');
        $(".ctm_filter_sidebar").addClass("open");
    });
    $(document).on("click",".filter__wrapper--header .back_btn, .filter_footer_btns .cancel_btn",function() {
        closeFilterDrawer();
    });

    // filter accordion 
    $(document).on("click",".filter_accodion--button",function() {
        // $(this).parents('.filter_accodion').siblings(".filter_accodion").removeClass("open");
        $(this).parents('.filter_accodion').toggleClass("open");
    });

    // filter tabs for mobile
    $(document).on("click",".mobile_filter_btn--name",function() {
        $(".mobile_filter_btn--name").removeClass("active");
        $(this).addClass("active");
        var tabId = $(this).attr("data-tab");
        $(".filter--block").removeClass("active");
        $("#" + tabId).addClass("active");
    });
    $(".mobile_filter_btn--name:first").addClass("active");
    $(".filter--block:first").addClass("active");


    // filter popup desktop

    $(document).on("click", ".show_more_filters_popup", function (event) {
        event.preventDefault();
        if ($(window).width() > 1024) {
            $('#FacetFiltersForm').css({position: "relative",overflow: "unset"});

            var targetId = $(this).parents(".filter_accodion--body").attr('id');
            var target = $("#" + targetId);
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 150,
                }, 500);
            }
            
            $(this).parents(".filter_accodion--content").addClass("filter_popup");
            $(this).parents(".filter_accodion--content").find('.hide_more').removeClass('hide');


        } else {
            $(this).siblings(".hide_more").toggleClass("hide");
            $(this).toggleClass("show_less");
        }
    });
    
  

    $(document).on("click",".show_more_filters",function(event) {
        event.preventDefault();
        $(this).siblings(".hide_more").toggleClass("hide");
        $(this).toggleClass("show_less");
    });

    $(document).on("mouseenter", ".filter_popup--alphabets a.enable", function (event) {
        event.preventDefault();
        let letter = $(this).attr("data");
        $(this).closest(".filter_accodion--content").find("[data-letter]").css("opacity", "0.4");
        $(this).closest(".filter_accodion--content").find(`[data-letter="${letter}"]`).css("opacity", "1");
    });
    
    $(document).on("mouseleave", ".filter_popup--alphabets a.enable", function (event) {
        event.preventDefault();
        $(this).closest(".filter_accodion--content").find("[data-letter]").css("opacity", "1");
    });

        $(".filter_popup--alphabets a").each(function () {
            let letter = $(this).attr("data");
            let hasMatchingItems = $(this).closest(".filter_accodion--content").find(`[data-letter="${letter}"]`).length > 0;
            if (!hasMatchingItems) {
                $(this).addClass("disable");
            } else {
                $(this).addClass("enable");
            }
        });
    
 
        $(document).on("keyup", ".filter-search", function () {
            let searchText = $(this).val().toLowerCase();
            let $items = $(this).closest('.filter_accodion--content').find(".filter_checkbox--item");
            
            if (searchText === "") {
                $items.removeAttr("style");
                return;
            }
            let matchCount = 0;
            $items.each(function () {
                let labelText = $(this).find(".checkbox_label").text().toLowerCase();
                if (labelText.includes(searchText) && matchCount < 8) {
                    this.setAttribute("style", "display: block !important;");
                    matchCount++;
                } else {
                    $(this).hide();
                }
            });
        });
        
        $(document).on("click", function(event) {
            if (!$(event.target).closest('.filter_accodion--content.filter_popup').length) {
                $('.filter_accodion--content.filter_popup').find('.hide_more').addClass('hide');
                $('.filter_accodion--content.filter_popup').removeClass('filter_popup');
                $('#FacetFiltersForm').css({position: "sticky",overflow: "auto"});
            }
        });
        
        
        $('.ctm_filter_sidebar').on("click", function(event) {
            if (!$(event.target).closest('.filter__wrapper').length){
            $(this).removeClass('open');
            }
        });
        

        // $('#best-seller input[type="checkbox"]').on('change', function () {
        //     $('#new-arrivals input[type="checkbox"]').prop('checked', false);
        // });

        // $('#new-arrivals input[type="checkbox"]').on('change', function () {
        //     $('#best-seller input[type="checkbox"]').prop('checked', false);
        // });
        $(document).on("change", ".facets__checkbox", function () {
            if ($(window).width() > 1024) {
                if(!$(this).parents(".filter_accodion--content").hasClass("filter_popup")){
                   if($(this).attr('id') == "Filter-filter.p.m.custom.new_arrivals-1" ){
                    $('#best-seller input[type="checkbox"]').prop('checked', false);
                   }else  if($(this).attr('id') == "Filter-filter.p.m.custom.best_seller-1" ){
                    $('#new-arrivals input[type="checkbox"]').prop('checked', false);
                   }

                   const formData = new FormData($(this)[0].closest('form'));
                   let searchParams = new URLSearchParams(formData);
                   if (!searchParams.has("sort_by")) {
                       let currentUrl = new URL(window.location.href);
                       let currentSortBy = currentUrl.searchParams.get("sort_by");
                       let filterCheckbox = $('[name="Filter-filter.p.m.custom.new_arrivals-1"]');
                       if (filterCheckbox.length && filterCheckbox.prop("checked") && currentSortBy === "created-descending") {
                          searchParams.set("sort_by", currentSortBy);
                       } else if (currentSortBy) {
                        searchParams.delete("sort_by");
                       }
                   }
                   const updatedUrl = searchParams.toString();            
                   var link = $('#FacetFiltersForm').attr('data-link');
                   ajaxfilterNew(`${link}?${updatedUrl}`);
                }else{
                    $(this).parents('.filter_checkbox--item').addClass('selected');
                }
            }else{
                if($(this).attr('id') == "Filter-filter.p.m.custom.new_arrivals-1" ){
                $('#best-seller input[type="checkbox"]').prop('checked', false);
                }else  if($(this).attr('id') == "Filter-filter.p.m.custom.best_seller-1" ){
                $('#new-arrivals input[type="checkbox"]').prop('checked', false);
                }
                $(this).parents('.filter_checkbox--item').addClass('selected');
            }
        });

        $(document).on("click",".close_filter_popup, .popup_clear_btn",function(event) {
            event.preventDefault();
            $(this).closest(".filter_accodion--content").find('.selected').removeClass("selected").find("input").prop("checked", false);
            $(this).parents(".filter_accodion--content").removeClass("filter_popup");
            $('#FacetFiltersForm').css({position: "sticky",overflow: "auto"});
            $(this).parents(".filter_accodion--content").find('.hide_more').addClass('hide');
        });
        $(document).on("click", ".clear_filter_btn, .filter_remove--btn:not(.not-js)", function (event) {
            event.preventDefault();
            if ($(this).hasClass("best-selling_rm")) {
                $('#best-seller input[type="checkbox"]').prop('checked', false);
                const formData = new FormData($(this)[0].closest('form'));
                let searchParams = new URLSearchParams(formData);
                if (!searchParams.has("sort_by")) {
                    let currentUrl = new URL(window.location.href);
                    let currentSortBy = currentUrl.searchParams.get("sort_by");
                
                    if (currentSortBy) {
                        searchParams.set("sort_by", currentSortBy);
                    }
                }
                const updatedUrl = searchParams.toString();            
                var link = $('#FacetFiltersForm').attr('data-link');
                ajaxfilterNew(`${link}?${updatedUrl}`);
            } else if ($(this).hasClass("new_arrivals_rm")) {
                $('#new-arrivals input[type="checkbox"]').prop('checked', false);
                const formData = new FormData($(this)[0].closest('form'));
                let searchParams = new URLSearchParams(formData);
                if (!searchParams.has("sort_by")) {
                    let currentUrl = new URL(window.location.href);
                    let currentSortBy = currentUrl.searchParams.get("sort_by");
                
                    if (currentSortBy) {
                        searchParams.delete("sort_by");
                    }
                }
                const updatedUrl = searchParams.toString();            
                var link = $('#FacetFiltersForm').attr('data-link');
                ajaxfilterNew(`${link}?${updatedUrl}`);
            } else {
                closeFilterDrawer();
            }
        
            let url = $(this).attr("href");
            ajaxfilterNew(url);
        });
        
        $(document).on("click", ".remove-all-ineer", function (event) {
            event.preventDefault();
            $(this).closest(".filter_accodion--body").find(".facets__checkbox:checked").prop("checked", false);
            const formData = new FormData($(this)[0].closest('form'));
            let searchParams = new URLSearchParams(formData);
            if (!searchParams.has("sort_by")) {
                let currentUrl = new URL(window.location.href);
                let currentSortBy = currentUrl.searchParams.get("sort_by");
            
                if (currentSortBy) {
                    searchParams.set("sort_by", currentSortBy);
                }
            }
            const updatedUrl = searchParams.toString();            
            var link = $('#FacetFiltersForm').attr('data-link');
            ajaxfilterNew(`${link}?${updatedUrl}`);

        });
        

        $(document).on("click",".popup_apply_btn",function(event) {
            event.preventDefault();
            $(this).parents(".filter_accodion--content").find('.hide_more').addClass('hide');
            $(this).parents(".filter_accodion--content").removeClass("filter_popup");
            $('#FacetFiltersForm').css({position: "sticky",overflow: "auto"});
            const formData = new FormData($(this)[0].closest('form'));
            let searchParams = new URLSearchParams(formData);
            if (!searchParams.has("sort_by")) {
                let currentUrl = new URL(window.location.href);
                let currentSortBy = currentUrl.searchParams.get("sort_by");
                let filterCheckbox = $('[name="Filter-filter.p.m.custom.new_arrivals-1"]');
                if (filterCheckbox.length && filterCheckbox.prop("checked") && currentSortBy === "created-descending") {
                   searchParams.set("sort_by", currentSortBy);
                } else if (currentSortBy) {
                 searchParams.delete("sort_by");
                }
            }
            const updatedUrl = searchParams.toString();            
            var link = $('#FacetFiltersForm').attr('data-link');
            ajaxfilterNew(`${link}?${updatedUrl}`);
        });

        $(document).on("click",".filter_footer_btns .apply_btn",function(event) {
            event.preventDefault();
            closeFilterDrawer();
            const formData = new FormData($(this)[0].closest('form'));
            let searchParams = new URLSearchParams(formData);
            if (!searchParams.has("sort_by")) {
                let currentUrl = new URL(window.location.href);
                let currentSortBy = currentUrl.searchParams.get("sort_by");
                let filterCheckbox = $('[name="Filter-filter.p.m.custom.new_arrivals-1"]');
                if (filterCheckbox.length && filterCheckbox.prop("checked") && currentSortBy === "created-descending") {
                   searchParams.set("sort_by", currentSortBy);
                } else if (currentSortBy) {
                 searchParams.delete("sort_by");
                }
            }
            const updatedUrl = searchParams.toString();            
            var link = $('#FacetFiltersForm').attr('data-link');
            ajaxfilterNew(`${link}?${updatedUrl}`);
        });

        
        $(document).on("click","#go-button",function(event) {
            event.preventDefault();
            closeFilterDrawer();
            const formData = new FormData($(this)[0].closest('form'));
            let searchParams = new URLSearchParams(formData);
            if (!searchParams.has("sort_by")) {
                let currentUrl = new URL(window.location.href);
                let currentSortBy = currentUrl.searchParams.get("sort_by");
            
                if (currentSortBy) {
                    searchParams.set("sort_by", currentSortBy);
                }
            }
            const updatedUrl = searchParams.toString();            
            var link = $('#FacetFiltersForm').attr('data-link');
            ajaxfilterNew(`${link}?${updatedUrl}`);
        }); 
        
        $(document).on("click", ".SortBy-label", function () {
            let selectBox = $(this).next("select");
            selectBox.trigger("mousedown").focus();
        });
        
        $(document).on("change", "#SortBy", function (event) {
            event.preventDefault();
            let selectedValue = $(this).val();
            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("sort_by", selectedValue);
            console.log(currentUrl.href);
            ajaxfilterNew(currentUrl.href);
        });
        



        class PriceRange extends HTMLElement {
            constructor() {
                super(),
                    (this.minRangeInput = this.querySelector('input[type="range"]:first-child')),
                    (this.maxRangeInput = this.querySelector('input[type="range"]:last-child')),
                    (this.minPriceInput = this.querySelector('input[name="filter.v.price.gte"]')),
                    (this.maxPriceInput = this.querySelector('input[name="filter.v.price.lte"]')),
                    this.minPriceInput.addEventListener("focus", this.minPriceInput.select),
                    this.maxPriceInput.addEventListener("focus", this.maxPriceInput.select),
                    this.minPriceInput.addEventListener("change", this.handleInputMinChange.bind(this)),
                    this.maxPriceInput.addEventListener("change", this.handleInputMaxChange.bind(this)),
                    this.minRangeInput.addEventListener("change", this.handleRangeMinChange.bind(this)),
                    this.maxRangeInput.addEventListener("change", this.handleRangeMaxChange.bind(this)),
                    this.minRangeInput.addEventListener("input", this.handleRangeMinInput.bind(this)),
                    this.maxRangeInput.addEventListener("input", this.handleRangeMaxInput.bind(this));
            }
            handleInputMinChange(event) {
                event.preventDefault(),
                    (event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.maxPriceInput.value || event.target.max) - 1), event.target.min)),
                    (this.minRangeInput.value = event.target.value),
                    this.minRangeInput.parentElement.style.setProperty("--range-min", `${(parseInt(this.minRangeInput.value) / parseInt(this.minRangeInput.max)) * 100}%`);
            }
            handleInputMaxChange(event) {
                event.preventDefault(),
                    (event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.minPriceInput.value || event.target.min) + 1), event.target.max)),
                    (this.maxRangeInput.value = event.target.value),
                    this.maxRangeInput.parentElement.style.setProperty("--range-max", `${(parseInt(this.maxRangeInput.value) / parseInt(this.maxRangeInput.max)) * 100}%`);
            }
            handleRangeMinChange(event) {
                event.stopPropagation(), (this.minPriceInput.value = event.target.value), this.minPriceInput.dispatchEvent(new Event("change", { bubbles: !0 }));
            }
            handleRangeMaxChange(event) {
                event.stopPropagation(), (this.maxPriceInput.value = event.target.value), this.maxPriceInput.dispatchEvent(new Event("change", { bubbles: !0 }));
            }
            handleRangeMinInput(event) {
                (event.target.value = Math.min(parseInt(event.target.value), parseInt(this.maxPriceInput.value || event.target.max) - 1)),
                    event.target.parentElement.style.setProperty("--range-min", `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`),
                    (this.minPriceInput.value = event.target.value);
            }
            handleRangeMaxInput(event) {
                (event.target.value = Math.max(parseInt(event.target.value), parseInt(this.minPriceInput.value || event.target.min) + 1)),
                    event.target.parentElement.style.setProperty("--range-max", `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`),
                    (this.maxPriceInput.value = event.target.value);
            }
        }
        customElements.define("price-range", PriceRange)

 
        // sticky filter sidebar 
        // let $sidebar = $(".filter__wrapper");
        // let $productList = $(".main-col .productList");
    
        // $(window).on("scroll", function () {
        //     let scrollY = $(window).scrollTop();
        //     let sidebarHeight = $sidebar.outerHeight();
        //     let productListOffset = $productList.offset().top;
        //     let productListHeight = $productList.outerHeight();
        //     let productListBottom = productListOffset + productListHeight;
    
        //     if (scrollY > 200) {
        //         $sidebar.addClass("fixed-sidebar").css({
        //             position: "fixed",
        //             top: "auto",
        //             bottom: "0px"
        //         });
        //     } else {
        //         $sidebar.removeClass("fixed-sidebar").css({
        //             position: "",
        //             top: "",
        //             bottom: ""
        //         });
        //     }
        //     if (scrollY + sidebarHeight >= productListBottom) {
        //         $sidebar.addClass("relative-sidebar").css({
        //             position: "relative",
        //             top: productListHeight - sidebarHeight + "px",
        //             bottom: "auto"
        //         });
        //     } else {
        //         $sidebar.removeClass("relative-sidebar");
        //     }
        // });

        var textValue = $(".total_active_values").text();
        if(textValue == '0' || textValue == '' ){
          $(".filters_count").hide();
        }else{
          $(".filters_count").text(textValue).css("display", "inline-flex");
        }

        $(window).scroll(function() {
            if ($(".stickyCart").length && $(window).scrollTop() > 600) {
                $("body").addClass("active-stickycart");
            } else {
                $("body").removeClass("active-stickycart");
            }
        });
        
});